import { Box, Typography } from '@mui/material'
import { scale } from '../../theme/scale'
import ScrollDownIndicator from './ScrollDownIndicator'
import {
  MOBILE_MQ,
  mobileBodyTextSx,
  mobilePaddingX,
  mobileSectionTitleSx,
} from '../../theme/mobileLayout'

export default function PageHero({
  title,
  subtitle,
  showScrollDown = false,
  centered = true,
  light = false,
  sx = {},
}) {
  const textColor = light ? '#fffefa' : 'inherit'
  const subtitleColor = light ? 'rgba(255,254,250,0.8)' : 'text.secondary'

  return (
    <Box
      sx={{
        pt: { xs: 8, md: 12 },
        pb: { xs: 6, md: 8 },
        px: mobilePaddingX,
        textAlign: centered ? 'center' : 'left',
        color: textColor,
        boxSizing: 'border-box',
        ...sx,
      }}
    >
      <Typography
        component="h1"
        sx={{
          ...mobileSectionTitleSx,
          fontSize: { ...mobileSectionTitleSx.fontSize, md: 72, lg: scale.fontSize.display },
          lineHeight: 1.1,
          fontWeight: 400,
          mb: subtitle ? 3 : 0,
          maxWidth: centered ? 1200 : 'none',
          mx: centered ? 'auto' : 0,
          [MOBILE_MQ]: { fontSize: 28 },
        }}
      >
        {title}
      </Typography>
      {subtitle && (
        <Typography
          sx={{
            ...mobileBodyTextSx,
            fontSize: { ...mobileBodyTextSx.fontSize, lg: scale.fontSize.label },
            lineHeight: 1.5,
            color: subtitleColor,
            maxWidth: centered ? 1200 : 1000,
            mx: centered ? 'auto' : 0,
          }}
        >
          {subtitle}
        </Typography>
      )}
      {showScrollDown && (
        <ScrollDownIndicator
          light={light}
          sx={{ mt: 6 }}
          textSx={{ fontSize: 18 }}
          gap={1}
        />
      )}
    </Box>
  )
}
